
/* injects from baggage-loader */

import React, {Component} from 'react';
import {Router} from "react-router";
import Config from "../../config/main";
import PropTypes from "prop-types";
import {getPageViewLogger} from "../../helpers/analytics";

class RouterBuilder extends Component {
    render () {
        let {props: {appHistory, store}} = this;

        return <Router history={appHistory} onUpdate={getPageViewLogger()}>
            {Config.env.skinExports.redirect /* specified index route may be defined by skin*/}
            {Config.env.skinExports.routerBuilder
                ? Config.env.skinExports.routerBuilder(store) /*partner requirements can be different we should give ability to specify custom routes and handlers vor skin*/
                : [
                    Config.env.skinExports.routes /* additional custom routes may be defined by skin */,
                    Config.env.skinExports.routeBuilder && Config.env.skinExports.routeBuilder(store) /* additional custom routes may be defined by skin */
                ]
            }
        </Router>;
    }
}

RouterBuilder.propTypes = {
    appHistory: PropTypes.object,
    store: PropTypes.object
};

export default RouterBuilder;